var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_525)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 38,
    height: 38,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8969 40.8981H33.7848V29.76C33.7848 27.1041 33.7374 23.685 30.0858 23.685C26.3816 23.685 25.8148 26.5789 25.8148 29.5667V40.8973H18.7029V17.9931H25.5303V21.1232H25.626C26.3092 19.9549 27.2966 18.9938 28.4829 18.3422C29.6692 17.6907 31.01 17.3731 32.3625 17.4233C39.5709 17.4233 40.8999 22.1648 40.8999 28.3331L40.8969 40.8981ZM10.6779 14.8624C8.39847 14.8628 6.55028 13.0151 6.54991 10.7357C6.54953 8.45627 8.39697 6.60808 10.6764 6.6077C12.9558 6.60714 14.804 8.45477 14.8044 10.7342C14.8046 11.8288 14.37 12.8787 13.5961 13.6529C12.8222 14.4271 11.7725 14.8621 10.6779 14.8624ZM14.234 40.8983H7.11447V17.9931H14.2338V40.8981L14.234 40.8983ZM44.4425 0.00263899H3.54072C1.60759 -0.019111 0.0222822 1.52945 -0.00134277 3.46258V44.535C0.0215322 46.4691 1.60666 48.0191 3.54053 47.9989H44.4425C46.3805 48.0229 47.9718 46.4728 47.9987 44.535V3.45939C47.9711 1.52251 46.3796 -0.025861 44.4425 -0.000548512",
    fill: "#0A66C2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosLinkedinIcon);
export default __webpack_public_path__ + "static/media/logos_linkedin-icon.6cac06c8b07f0d12f6931fd10fccd1be.svg";
export { ForwardRef as ReactComponent };